<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h4 class="m-0">Profile</h4>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active">
                <span>Profile</span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="card card-plb">
              <div class="card-header ui-sortable-handle">
                <h5 class="card-title card_title_margin">
                  <i class="nav-icon fa-solid fa-user-edit"></i>
                  Profile
                </h5>
                <div class="card-tools">
                  <button
                    type="button"
                    data-card-widget="collapse"
                    class="btn btn-tool"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <!-- BEGIN: Card Body -->
              <div class="card-body">
                <div class="row justify-content-center">
                  <!-- Profile Summary -->
                  <div class="col-md-4 border-right">
                    <div
                      class="d-flex flex-column align-items-center text-center p-3 pt-5"
                    >
                      <div class="text-center">
                        <img
                          class="profile-user-img img-fluid img-circle"
                          alt="User profile picture"
                          :src="avatarUrl() + users.avatar"
                        />
                      </div>
                      <!-- Button to  Change Avatar -->
                      <div class="mt-3">
                        <button
                          id="change-avatar"
                          type="button"
                          class="btn btn-secondary btn-sm"
                          data-toggle="modal"
                          data-target="#modal-default"
                        >
                          Change Avatar
                        </button>
                      </div>
                    </div>

                    <div class="d-flex flex-column p-3 py-1">
                      <h4 class="profile-username mb-3">Security Details</h4>
                      <p class="text-muted">
                        <strong>IP Address:</strong> {{ last_login_ip }}
                      </p>
                      <p class="text-muted">
                        <strong>Last login:</strong> {{ last_login_at }}
                      </p>
                      <p class="text-muted">
                        <strong>Last Browser:</strong> {{ last_login_device }}
                      </p>

                      <p class="text-muted">
                        <strong>Last Activity:</strong> {{ last_activity }}
                      </p>
                    </div>
                  </div>

                  <!-- BEGIN: Profile Details -->
                  <div class="col-md-8 border-right">
                    <div class="p-3 py-5">
                      <div
                        class="d-flex justify-content-between align-items-center mb-3"
                      >
                        <h4 class="text-right">Profile Details</h4>
                      </div>

                      <div>
                        <div class="row mt-2">
                          <div class="col-md-6">
                            <label class="labels">Name</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Please enter your name"
                              v-model="form.name"
                              :class="{
                                'is-invalid': form.errors.has('name'),
                              }"
                              autofocus
                            />
                            <HasError :form="form" field="name" />
                          </div>

                          <div class="col-md-6">
                            <label class="labels">Username</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Please enter your username"
                              v-model="form.username"
                              :class="{
                                'is-invalid': form.errors.has('username'),
                              }"
                            />
                            <HasError :form="form" field="username" />
                          </div>
                        </div>

                        <div class="row mt-3">
                          <div class="col-md-6">
                            <label class="labels">Email Address</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Please enter your email address"
                              v-model="form.email"
                              :class="{
                                'is-invalid': form.errors.has('email'),
                              }"
                            />
                            <HasError :form="form" field="email" />
                          </div>
                          <div class="col-md-6">
                            <label class="labels">Password</label>
                            <input
                              type="password"
                              class="form-control"
                              placeholder="Please enter your password"
                              v-model="form.password"
                              :class="{
                                'is-invalid': form.errors.has('password'),
                              }"
                            />
                            <HasError :form="form" field="password" />
                          </div>
                        </div>

                        <!-- Make textarea for description rounded -->
                        <div class="row mt-3">
                          <div class="col-md-12">
                            <label class="labels">Description</label>
                            <textarea
                              class="form-control"
                              rows="4"
                              placeholder="Please enter a description (optional)"
                              v-model="form.description"
                              :class="{
                                'is-invalid': form.errors.has('description'),
                              }"
                            ></textarea>
                            <HasError :form="form" field="description" />
                          </div>
                        </div>

                        <!-- Confirm Button -->
                        <div class="mt-3">
                          <button
                            class="btn btn-primary"
                            @click="updateProfile"
                          >
                            Save Profile
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END: Profile Details -->
                </div>
              </div>
              <!-- END: Card Body -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BEGIN: Modal Avatar -->
    <div class="modal fade" id="modal-default">
      <!-- BEGIN: Modal Dialog -->
      <div class="modal-dialog">
        <!-- BEGIN: Modal Content -->
        <div class="modal-content">
          <!-- BEGIN: Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Upload a personal avatar</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- END: Modal Header -->

          <!-- BEGIN: Modal Body -->
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="avatar"
                  >Select an image to use as your avatar:</label
                >
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="avatar" />
                  <label class="custom-file-label" for="avatar"
                    >Choose file</label
                  >
                </div>
              </div>
            </form>
          </div>
          <!-- END: Modal Body -->

          <!-- BEGIN: Modal Footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
          <!-- END: Modal Footer -->
        </div>
        <!-- END: Modal Content -->
      </div>
      <!-- END: Modal Dialog -->
    </div>
    <!-- END: Modal Avatar -->
  </div>
</template>
<script>
import Form from "vform";
import axios from "axios";
import debounce from "lodash/debounce";
import Swal from "sweetalert2";
import moment from "moment";
moment.locale("id");

export default {
  name: "Profile",
  data() {
    return {
      avatarUrl() {
        return "http://localhost:8000/uploads/avatars/";
      },
      // BEGIN: Data
      users: {
        data: [],
      },
      last_login_at: "",
      last_login_ip: "",
      last_login_device: "",
      last_activity: "",
      form: new Form({
        name: "",
        username: "",
        email: "",
        password: "",
        description: "",
      }),
    };
  },

  methods: {
    // END: Validate Form

    updateProfile() {
      axios
        .post("http://localhost:8000/api/profile", this.form)
        .then((response) => {
          this.loading = false;
          this.success = true;
          this.showSuccess();
          this.getProfile();
        })
        .catch((error) => {
          this.loading = false;
          this.success = false;
          this.showFailed();
        });
    },

    showSuccess() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Your profile has been updated",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
    },

    showFailed() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Your profile failed to update",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
    },

    showLoading() {
      Swal.fire({
        didOpen: () => {
          Swal.showLoading();
        },
        background: "transparent",
        allowOutsideClick: false,
      });
    },
    // END: Method
  },
  mounted() {
    // BEGIN: Mounted

    // Get profile data
    axios.get("/api/profile").then((response) => {
      this.form = response.data.data;
      this.users = response.data.data;
      this.last_login_at = moment(response.data.last_login_at).format(
        "dddd, DD MMMM YYYY HH:mm:ss"
      );
      this.last_login_ip = response.data.last_login_ip;
      this.last_login_device = response.data.last_login_device;
      this.last_activity = response.data.last_activity;
    });
    // END: Mounted
  },
};
</script>
